import Card from "./Card";
export default function StatCard({ icon = "📊", label, value, helper, children }) {
  return (
    <Card>
      <div className="flex items-center gap-3">
        <div className="w-11 h-11 flex items-center justify-center text-lg bg-palette-indigo-soft rounded-xl">
          {icon}
        </div>
        <div className="flex-1 min-w-0">
          <div className="text-xs text-palette-gray-secondary">{label}</div>
          {children ?? (
            <>
              <div className="text-2xl font-extrabold leading-tight">{value}</div>
              {helper && <div className="text-xs text-palette-gray-secondary">{helper}</div>}
            </>
          )}
        </div>
      </div>
    </Card>
  );
}
